<template>
 <div class="container">
   <div class="back-link pt-33">
     <router-link :to="{ name: 'activity-questions', params: { activityId: activityId}, query: {studyId: studyId}}" class="d-block tags-page__back-to-activities fs-14">
       <img src="static/img/activity-configurator/arrow-left.svg" alt="" class="back_arrow">
       Back to Activity
     </router-link>
   </div>
   <div class="list-container">
     <div class="row d-flex mb-28" :no-gutters="true">
       <div class="col-6 d-flex align-items-center pl-0">
         <img src="static/img/activity-configurator/activity-frame-step.svg" alt=""/>
         <div class="new-heading" data-testid="advanced-scoring-title">Advanced Scoring - Variables</div>
       </div>
       <div class="col-6 text-right pr-0">
       <button class="btn btn-info create-variable-btn" @click="openVariableCalculationModal()" data-testid="create-variable">
         Create Variable
       </button>
       </div>
     </div>
     <div>
       <table class="table">
         <thead class="table-border fs-12">
         <tr>
           <th v-for="(field, index) in variableFields" :key ="`${field.key}-${index}`">
             <span> {{field.label}}</span>
           </th>
           <th></th>
         </tr>
         </thead>
         <tbody v-if="variablesList && variablesList.length > 0">
         <tr v-for="(variable, index) in variablesList" :key="`${variable.id}-${index}`">
           <td class="align-middle variable-name" @click="openVariableCalculationModal(variable)">{{variable.name}}</td>
           <td class="align-middle calculation-formula">{{ variable.formula }}</td>
           <td class="text-right pr-0">
             <button class="delete-button" v-on:click="getFilterVariables(variable)">
              <i class="fa fa-trash fs-20" aria-hidden="true" style="color: #abb4b9;"></i>
              </button>
           </td>
         </tr>
         </tbody>
         <tbody v-else-if="variablesList && variablesList.length==0">
         <tr>
           <td :colspan="colspan">
             <div class="emptyGrid">
               {{"No customized variables found."}}
             </div>
           </td>
         </tr>
         </tbody>
         <tbody v-else>
         <tr>
           <td :colspan="colspan">
             <div class="snippet" data-title=".dot-stretching">
               <div class="stage">
                 <div class="dot-stretching"></div>
               </div>
             </div>
           </td>
         </tr>
         </tbody>
       </table>
     </div>
   </div>
   <!-- variable calculation modal -->
   <variableCalculationModal ref="variableCalculationModal" @refreshVariablesList="getAllVariablesList" :variablesListData = "this.variablesList" />
 </div>
</template>

<script>
import variableCalculationModal from "@/components/activity-library/variable-calculation-modal";
import swal from "sweetalert2";
import nprogress from "nprogress";
export default {
  name: "activity-advanced-scoring",
  data(){
    return {
      activityId: undefined,
      variablesList:null,
      variableFields: [
        {
          key: "name",
          label: "Variable Name",
        },
        {
          key: "formula",
          label: "Formula",
        },
      ],
      colspan: 3,
      studyId: undefined,
    }
  },
  components: {variableCalculationModal},
  methods: {
    openVariableCalculationModal(variable){
      if(variable){
        this.$refs.variableCalculationModal.show(variable);
      }
      else{
        this.$refs.variableCalculationModal.show();
      }

    },
    getFilterVariables(variable){
      let filterName = variable.name;
      let pathParams = { activityRevisionId: this.activityId };
      let queryParams = { name: filterName };
      this.$api.getFilterVariableDetails(pathParams, queryParams).then(response => {
        let responseData = response.body.variables;
        if (responseData && responseData.length > 0) {
          swal({
            title:
                `<span>"${variable.name}" is being used in other custom variables.</span> \n
                  <span>You cannot delete this variable until you remove \n its use in other custom variable formulas.</span>`,
            type: "warning",
            showCancelButton: false,
            confirmButtonColor: "#4c8ce4",
            confirmButtonText: "I understand",
            customClass: "custom-cancel",
            allowOutsideClick: false,
            showCloseButton: true
          })
        } else {
          this.deleteVariable(variable)
        }
      }, error => {
        this.$toastr.error(
            error.body && error.body.message
                ? error.body.message
                : "Error while getting filter variables details."
        );
      });
    },
    deleteVariable(variable){
        let pathParams = {
        activityRevisionId: this.activityId,
        variableId: variable.id
      }
      swal({
        title:`Are you sure you want to delete variable,\n "${variable.name}" ?`,
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#f16559",
        cancelButtonColor: "#b8c7ce",
        confirmButtonText: "Delete Variable",
        cancelButtonText: "Cancel",
        customClass: "custom-sweet-alert",
        reverseButtons: true,
        showCloseButton: true,
        allowOutsideClick: false,
      }).then(({  value }) => {
        if (value) {
          this.$api.deleteVariable(pathParams).then(response => {
            this.$toastr.success("Variable deleted successfully");
            this.getAllVariablesList();
          }, error => {
            this.$toastr.error(
                error.body && error.body.message
                    ? error.body.message
                    : "Error while deleting variable."
            );
          })
        }
      });
    },
    getAllVariablesList() {
      let activityId = this.$route.query.routeActivityId
      let pathParams = {
        activityRevisionId: this.activityId
      };
      nprogress.start();
      this.$api.getAllVariables(pathParams)
          .then(
              response => {
                this.variablesList = response.body;
                nprogress.done();
              },
              error => {
                nprogress.done();
                this.$toastr.error(
                    error.body && error.body.message
                        ? error.body.message
                        : "Error while getting variable list."
                );
              }
          );
    },
  },
  mounted() {
    this.activityId = this.$route.params.activityId;
    this.studyId = this.$route.query.studyId;
    this.getAllVariablesList();
  },
}
</script>
<style scoped lang="scss" src="@/assets/dot-streaching-loader.scss"></style>
<style scoped lang="scss" src="../../../public/static/fonts.scss"></style>
<style scoped lang="scss">
.back-link {
  font-family: "RobotoRegular",serif;
  &__back-to-activites {
    color: #4c8ce4;
  }
}

.row {
  display: block;

  &:after {
    content: "";
    clear: both;
    display: block;
  }
}
.back_arrow {
  height: 13px;
  margin-top: -3px;
}

.new-heading {
  font-size: 20px;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #666669;
}

.list-container {
  width: 1166px;
  height: auto;
  min-height: 507px;
  flex-grow: 0;
  flex-direction: column;
  justify-content: flex-start;
  padding: 24px;
  background-color: #fff;
  margin-bottom: 74px;
  margin-top: 32px;
  position: relative;
}

.table-striped > tbody > tr:nth-of-type(odd) {
  background-color: #f5f8fa !important;
}

.table {
  margin-bottom: 0;
  color: #4a4a4a;

  thead {
    border: 1px solid #e4e8eb;
    border-right: 0;
    border-left: 0;

    th {
      color: #9b9b9b !important;
      border-top: none;
      border-bottom: none;
      vertical-align: top;
      padding-left: 16px;
      width: 350px;
      font-weight: bold;
      font-size: 12px;
      background: rgba(249, 249, 251, 0.2);
      padding-top: 6px;
      padding-bottom: 6px;
    }
  }
  th,
  td {
    padding: 10px 10px 10px 16px;
    word-break: break-all;
    &.link{
      color: #1e8fe1;
      font-weight: bold;
      cursor: pointer;
    }
  }
  .variable-name{
    width: 190px;
    max-width: 200px;
    flex-grow: 0;
    font-size: 14px;
    font-weight: bold;
    line-height: 1.14;
    text-align: left;
    color: #4c8ce4;
    cursor: pointer;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .calculation-formula{
    white-space: nowrap;
    width: 558px;
    max-width: 700px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
.table-border {
  border-bottom: 1px solid #e4e8eb !important;
  border-top: 1px solid #e4e8eb !important;
}

.emptyGrid {
  position: absolute;
  top: 58%;
  left:42%;
  color: #4a4a4a;
}

.delete-button{
  width: 24px;
  height: 24px;
  border: none;
  border-radius: 4px;
  justify-content: center;
  align-items: center;
  padding: 0;
  background-color: transparent;
}

.delete-button:hover {
  background-color: rgba(241, 101, 89, 0.3);
  cursor: pointer;
}

.stage {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  padding: 2rem 0;
  margin: 0 -5%;
  overflow: hidden;
}

.create-variable-btn {
    padding-right: 34px;
    padding-left: 34px;
}
</style>